import type { ComponentType } from 'react';

export type GenericComment = {
  id: number;
  comment: string;
  createdAt: Date;
  internal: boolean;
  displayName?: string;
  email?: string;
  contactId?: number;
  deletedAt?: Date;
  archivedAt?: Date;
};

export const LifecycleAction = {
  Archive: 'Archive',
  Restore: 'Restore',
  Delete: 'Delete',
} as const;

export type LifecycleActionType = (typeof LifecycleAction)[keyof typeof LifecycleAction];

export type CommentInputProps = {
  onSubmit: (comment: string, internal: boolean) => void;
  inputIdSuffix?: string;
  disabledInternalComments?: boolean;
};

export type CommentsProps = {
  inputIdSuffix?: string;
  disablePost?: boolean;
  postComment: (comment: string, internal: boolean) => void;
  updateComment?: (comment: GenericComment) => void;
  handleLifecycleClick?: (commentId: number, action: LifecycleActionType) => void;
  comments: GenericComment[];
  disabledInternalComments?: boolean;
  canModerateAllPosts?: boolean;
  contactId?: number;
  InputComponent?: ComponentType<CommentInputProps>;
  highlightCommentId?: number;
};
